import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = ({ className }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    inquiryType: "",
    userType: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const templateParams = {
  //     to_name: "Admin", // Or dynamically set it
  //     firstName: formData.firstName,
  //     lastName: formData.lastName,
  //     email: formData.email,
  //     inquiryType: formData.inquiryType,
  //     userType: formData.userType,
  //     message: formData.message,
  //   };

  //   emailjs
  //     .send(
  //       "service_bl1zn88", // EmailJS service ID
  //       "template_f5cj7no", // EmailJS template ID
  //       templateParams,
  //       "1t8OSwC1OTJ-KQS2G" // EmailJS public key
  //     )
  //     .then(
  //       (result) => {
  //         console.log("SUCCESS!", result.text);
  //         alert("Your message has been sent successfully!");
  //         setFormData({
  //           firstName: "",
  //           lastName: "",
  //           email: "",
  //           inquiryType: "",
  //           userType: "",
  //           message: "",
  //         });
  //       },
  //       (error) => {
  //         console.log("FAILED...", error.text);
  //         alert("There was an error sending your message. Please try again.");
  //       }
  //     );
  // };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const templateParams = {
      to_name: "Admin", // Or dynamically set it
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      inquiryType: formData.inquiryType,
      userType: formData.userType,
      message: formData.message,
    };
  
    try {
      // Send data to MongoDB
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        throw new Error("Failed to store data in MongoDB");
      }
  
      console.log("Data successfully stored in MongoDB");
  
      // Send Email via EmailJS
      emailjs
        .send(
          "service_bl1zn88", // EmailJS service ID
          "template_f5cj7no", // EmailJS template ID
          templateParams,
          "1t8OSwC1OTJ-KQS2G" // EmailJS public key
        )
        .then(
          (result) => {
            console.log("Email Sent Successfully!", result.text);
            alert("Your message has been sent and stored successfully!");
  
            // Reset form after successful submission
            setFormData({
              firstName: "",
              lastName: "",
              email: "",
              inquiryType: "",
              userType: "",
              message: "",
            });
          },
          (error) => {
            console.error("Email sending failed...", error.text);
            alert("There was an error sending your message. Please try again.");
          }
        );
    } catch (error) {
      console.error("Submission Failed:", error.message);
      alert("There was an error submitting your form. Please try again later.");
    }
  };
  

  return (
    <div className={`mr-3 ${className} `}>
      <h2 className="text-3xl md:text-2xl lg:text-6xl font-semibold text-gray-800 mb-4">
        Have a question?
      </h2>
      <p className="text-lg text-gray-600 mb-8">
        Fill the form below and we’ll get back to you as soon as we can.
      </p>
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="grid grid-cols-2 gap-4">
          <input
            type="text"
            placeholder="First name"
            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder="Last name"
            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <input
          type="email"
          placeholder="Email"
          className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <div className="grid grid-cols-2 gap-4">
          <select
            className="w-full p-4 border border-gray-300 rounded-lg text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600"
            name="inquiryType"
            value={formData.inquiryType}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              What would you like to ask about?
            </option>
            <option value="Admissions">Educational Tours</option>
            <option value="Programs">Study Abroad</option>
            <option value="Other">Other</option>
          </select>
          <select
            className="w-full p-4 border border-gray-300 rounded-lg text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600"
            name="userType"
            value={formData.userType}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              Are you...?
            </option>
            <option value="Student">Student</option>
            <option value="Parent">Parent</option>
            <option value="Other">School/Institution</option>
          </select>
        </div>
        <textarea
          placeholder="Your Message"
          rows="5"
          className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button
          type="submit"
          className="w-full py-4 bg-black text-white font-semibold rounded-lg hover:bg-blue-700 transition"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
